import {
  createTRPCContext,
  createTRPCOptionsProxy,
} from "@trpc/tanstack-react-query";
import { createTRPCClient, httpBatchLink, httpLink, splitLink } from "@trpc/client";
import type { AppRouter } from "../../../backend/src/entrypoints/api/index";
import { queryClient } from "./tanstack-query";
import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server';

export const { TRPCProvider, useTRPC, useTRPCClient } =
  createTRPCContext<AppRouter>();

export type RouterInput = inferRouterInputs<AppRouter>;
export type RouterOutput = inferRouterOutputs<AppRouter>;

const baseLinkOptions = {
  url: import.meta.env.VITE_BACKEND_URL,
  fetch(url: Parameters<typeof fetch>[0], options?: Parameters<typeof fetch>[1]) {
    return fetch(url, {
      ...options,
      credentials: "include",
      signal: AbortSignal.timeout(15 * 60 * 1000), // 15 minute timeout
    });
  },
  headers() {
    const authObject: Record<string, string> = JSON.parse(localStorage.getItem(`sb-${import.meta.env.VITE_SUPABASE_PROJECT_ID}-auth-token`) ?? "{}");
    const token = authObject['access_token'];
    if (!token) {
      return {};
    }
    return {
      Authorization: `Bearer ${token}`, 
    };
  },
};

export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    splitLink({
      condition(op) {
        return op.context.noBatch === true;
      },
      true: httpLink(baseLinkOptions),
      false: httpBatchLink(baseLinkOptions),
    }),
  ],
});

export const trpc = createTRPCOptionsProxy<AppRouter>({
  client: trpcClient,
  queryClient: queryClient,
});
